import React from "react";

// Ticket #224 fase 2 — subcomponente memoizado de la CAJA 7 del HUD
// (minimapa + name del mapa + coords + dots de player/party).
//
// El array `partyMembers` llega con un nuevo reference en cada render
// del padre (`getPartyMembersForMap` devuelve array fresco). Una shallow
// comparison fallaría siempre.
//
// Solución: shouldComponentUpdate custom que compara solo los PRIMITIVOS
// que indican cambios reales:
//   - mapNumber, nameMap        → cambio de mapa
//   - userPosX, userPosY        → tu posición cambió
//   - userFactionClass          → seguro on/off (ciudadano ↔ criminal)
//   - showPartyOnMap            → toggle del feature
//   - partyHash                 → "name:x:y|name:x:y|..." hash de party
//                                 (cambia cuando party miembro se mueve)
//
// setStates del padre que no tocan ninguno de estos (HP/Mana update,
// inventario, modales, chat) NO triggerean re-render acá.
// Ticket #261: extends Component (NO PureComponent) — `shouldComponentUpdate`
// custom es incompatible con PureComponent (warning de React).
export default class MapBox extends React.Component {
    shouldComponentUpdate(nextProps) {
        const p = this.props;
        return (
            p.mapNumber !== nextProps.mapNumber ||
            p.nameMap !== nextProps.nameMap ||
            p.userPosX !== nextProps.userPosX ||
            p.userPosY !== nextProps.userPosY ||
            p.userFactionClass !== nextProps.userFactionClass ||
            p.showPartyOnMap !== nextProps.showPartyOnMap ||
            p.partyHash !== nextProps.partyHash ||
            p.clanHash !== nextProps.clanHash
        );
    }

    render() {
        const {
            style,
            mapNumber,
            nameMap,
            userPosX,
            userPosY,
            userFactionClass,
            showPartyOnMap,
            partyMembers,
            getFactionClassSuffix,
            clanMembers
        } = this.props;

        return (
            <div className={style.mapBox}>
                <div className={style.mapName}>{nameMap || "—"}</div>
                <div
                    className={style.minimap}
                    style={{
                        backgroundImage: mapNumber
                            ? `url('/static/imgs_mapas/${mapNumber}.png')`
                            : "none"
                    }}
                >
                    {/* Ticket #312 fix: factor de escala 0.86 = 86px del
                        minimap / 100 tiles. Antes era 0.7 (correcto cuando
                        minimap medía 70px); al bumpear a 86px el factor
                        no se actualizó y todos los dots quedaban ~18%
                        atrasados de la pos real. */}
                    {showPartyOnMap === "show" &&
                        partyMembers.map(m => (
                            <div
                                key={"party_mini_" + m.name}
                                className={`${style.partyDotMinimap} ${
                                    style[
                                        "partyDotMinimap" +
                                            getFactionClassSuffix(m)
                                    ]
                                }`}
                                style={{
                                    top: `${(m.y - 1) * 0.86}px`,
                                    left: `${(m.x - 1) * 0.86}px`
                                }}
                                title={m.name + " (party)"}
                            />
                        ))}
                    {/* Ticket #313: dots de miembros del clan en el mismo
                        mapa que el viewer. Color amber del clan. */}
                    {clanMembers && clanMembers.map(m => (
                        <div
                            key={"clan_mini_" + m.name}
                            className={style.clanDotMinimap}
                            style={{
                                top: `${(m.y - 1) * 0.86}px`,
                                left: `${(m.x - 1) * 0.86}px`
                            }}
                            title={m.name + " (clan)"}
                        />
                    ))}
                    <div
                        className={`${style.point_minimap} ${
                            style[
                                "point_minimap_" + userFactionClass.toLowerCase()
                            ]
                        }`}
                        style={{
                            top: userPosX != null ? `${(userPosY - 1) * 0.86}px` : 0,
                            left: userPosX != null ? `${(userPosX - 1) * 0.86}px` : 0
                        }}
                    />
                </div>
                <div className={style.mapCoords}>
                    {userPosX != null
                        ? `Mapa ${mapNumber} (${userPosX}, ${userPosY})`
                        : ""}
                </div>
            </div>
        );
    }
}
